import { Directive, ElementRef, Renderer, Input, Output, Optional, EventEmitter } from '@angular/core';


export class FroalaViewDirective {

  private _element: HTMLElement;
  private _content: any;

  constructor(private renderer: Renderer, element: ElementRef) {
    this._element = element.nativeElement;
  }

  // update content model as it comes
   set froalaView(content: string){
    this._element.innerHTML = content;
  }

  ngAfterViewInit() {
    this.renderer.setElementClass(this._element, "fr-view", true);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[froalaView]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'froalaView': [{ type: Input },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
